
import menuMixin from "@/mixins/menu"

export default menuMixin.extend({
  data: () => ({
    isMenuOpen: false,
  }),

  watch: {
    $route: {
      handler () { this.isMenuOpen = false },
      deep: true,
    },

    isMenuOpen (isMenuOpen) {
      if (isMenuOpen) setTimeout(() => {
        (this.$refs.nav as HTMLElement)?.focus()
      }, 200)
      else setTimeout(() => {
        document.querySelector("a")?.focus()
      }, 200)
    },
  },
})
